<template>
  <div v-if="isMobile" class="mt-32" :class="customClass">
    <p class="ltr:maxMd:pl-5 rtl:maxMd:pr-5 font-display text-2xl font-bold mb-4 text-gray-900"> {{ $t(title).tTitle() }}</p>
    <div class="submenubar bg-white fixed top-[70px] pt-3 w-full z-[2]">
      <HorizontalScrollable :items="matchedRoutes">
        <ButtonGroup mode="secondary" customClasses="mb-3 first:ml-2 last:mr-2" :options="routesArray" :selectedOption="activeRoute"
          @click="(opt) => $router.push(pathWithLanguage(matchedRoutes.find(r => r.title == opt).path))" />
      </HorizontalScrollable>
    </div>

  </div>
  <div v-else class="hidden md:block lg:px-0 mt-32 md:mt-0" :class="customClass+'-desktop'">
    <p class="ltr:maxMd:pl-5 rtl:maxMd:pr-5 font-display text-2xl font-bold mb-4 text-gray-900">{{ $t(title).tTitle() }}</p>
    <HorizontalScrollable :items="matchedRoutes">
      <ButtonGroup mode="secondary" customClasses="mb-3" :options="routesArray" :selectedOption="activeRoute"
        @click="(opt) => $router.push(pathWithLanguage(matchedRoutes.find(r => r.title == opt).path))" />
    </HorizontalScrollable>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import ButtonGroup from './reusableComponents/ButtonGroup.vue'
import HorizontalScrollable from './reusableComponents/HorizontalScrollable.vue'
export default {
  components: {
    ButtonGroup,
    HorizontalScrollable
  },
  props: {
    title: String,
    routes: Array,
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: false
    }
  },
  computed: {
    matchedRoutes() {
      return this.routes.map(route => ({ ...route, isActive: this.pathWithoutLanguage(this.$route.fullPath) === this.pathWithoutLanguage(route.path) }))
    },
    routesArray() {
      return this.matchedRoutes.map(route => route.title)
    },
    activeRoute() {
      return this.matchedRoutes.find(r => r.isActive).title
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile)
  },
  methods: {
    pathWithLanguage(path) {
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      if (path.endsWith('/')) {
        path = path.slice(0, -1)
      }
      let parts = path.split('/')
      if (parts[1].length === 2) {
        return parts.join('/')
      }
      parts = parts.filter(p => p.length > 0)
      parts.unshift('', this.Language)
      return parts.join('/')
    },
    pathWithoutLanguage(path) {
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      if (path.endsWith('/')) {
        path = path.slice(0, -1)
      }
      let parts = path.split('/')
      if (parts[1].length === 2) {
        parts.splice(1, 1)
      }
      return parts.join('/')
    },
    checkIsMobile() {
      if (document.body.clientWidth <= 752) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  },
}
</script>

<style></style>
